import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'frodo-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() backgroundColor: string;
  @Input() text: string;
  @Input() disable?: boolean;
  @Output() onClick = new EventEmitter<any>();

  private readonly disabledColor = '#dddddd';

  get resolvedBackgroundColor(): string {
    return this.disable ? this.disabledColor : this.backgroundColor;
  }

  onClickPressed() {
    this.onClick.emit();
  }
}
